const FOCUSABLE =
  'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'

export function createFocusTrap(container, { onEscape } = {}) {
  let previouslyFocused = null

  const focusables = () => Array.from(container.querySelectorAll(FOCUSABLE))

  const onKeydown = e => {
    if (e.key === 'Escape') {
      if (onEscape) onEscape()
      return
    }
    if (e.key !== 'Tab') return
    const items = focusables()
    if (!items.length) return
    const firstEl = items[0]
    const lastEl = items[items.length - 1]
    if (e.shiftKey && document.activeElement === firstEl) {
      e.preventDefault()
      lastEl.focus()
    } else if (!e.shiftKey && document.activeElement === lastEl) {
      e.preventDefault()
      firstEl.focus()
    }
  }

  return {
    activate() {
      previouslyFocused = document.activeElement
      const items = focusables()
      if (items.length) items[0].focus()
      document.addEventListener('keydown', onKeydown)
    },
    deactivate() {
      document.removeEventListener('keydown', onKeydown)
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus()
    }
  }
}
